import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const AppContext = React.createContext();

 export const AppProvider = ({ children }) => {
//   const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
//   const [baseUrlForFiles, setBaseUrlForFiles] = useState(
//     "http://127.0.0.1:8000/storage",
//   );
  const [baseUrl, setBaseUrl] = useState("https://estateexperts.btsportfolio2026.com/backend/public/api");
  const [baseUrlForFiles, setBaseUrlForFiles] = useState(
    "https://estateexperts.btsportfolio2026.com/backend/public/storage",
  );
  const [profileData, setProfileData] = useState();
  const [loggedInBuyer, setLoggedInBuyer] = useState();
  const [loggedInSeller, setLoggedInSeller] = useState();
    // JSON.parse(localStorage.getItem("loggedInSeller")) || {});
  const [loggedInAdmin, setLoggedInAdmin] = useState();
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const Navigate = useNavigate();

  /////////////////////////////////validation//////////////////////////////////////
  const fullNameRegExp = new RegExp(/^[A-Za-z]{5,}$/);
  const emailRegExp = new RegExp(
    /^[A-Za-z0-9#$%_!&.?]{5,}@[a-z0-9]{3,}.[a-z0-9]{2,}$/,
  );
  const passwordRegExg = new RegExp(/^[A-Za-z0-9#$%_!&.?]{8,}$/);
  const phoneNumberRegExp = new RegExp(/^[0-9]{4,4}-[0-9]{7,7}$/);
  const CNICRegExp = new RegExp(/^[0-9]{5,5}-[0-9]{7,7}-[0-9]{1,1}$/);

  const regExpChecker = (type, input) => {
    switch (type) {
      case "fullName":
        if (!fullNameRegExp.test(input)) {
          return "fullname must be at least 5 characters long contains only one letters";
        }
        break;
      case "email":
        if (!emailRegExp.test(input)) {
          return "Email must be in the format: john1233@example.com";
        }
        break;
      case "password":
        console.log("password case called");
        if (!passwordRegExg.test(input)) {
          return (
            "Password must be at least 8 characters long and can contain letters, numbers and special characters",
            console.log("password case. error called")
          );
        }
        break;
      case "phoneNumber":
        if (!phoneNumberRegExp.test(input)) {
          return "Phone Number must be in the format: 0300-1234567";
        }
        break;
      case "CNIC":
        if (!CNICRegExp.test(input)) {
          return "CNIC number must be in the format: 12345-1234567-1";
        }
        break;
    }
  };

  
  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlForFiles,
        authToken,
        profileData,
        setProfileData,
        setAuthToken,
        Navigate,
        regExpChecker,
        setLoggedInBuyer,
        setLoggedInSeller,
        loggedInBuyer,
        loggedInSeller,
        setLoggedInAdmin,
        loggedInAdmin,
        setLoggedInSeller,
        loggedInSeller,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export default AppContext;
